export const NUMBER_OF_JOKES = 20;
export const NUMBER_OF_CATEGORY_JOKES = 5;
export const NUMBER_OF_ATTEMPTS = 20;
